	
	

export const ComiteListOrganization = 
  [
    {
      coordenador: 'MÍRIAN SANDRA ROSA GUSMÃO',
      area: 'Diretora da Escola Politécnica'
    },

    {
      coordenador: 'ANDRÉ LUIZ ALVES',
      area: 'Coordenador de Engenharia de Computação'
    },

    {
      coordenador: 'CARMEN CECÍLIA CENTENO',
      area: 'Coordenadora de Ciência da Computação'
    },

    {
      coordenador: 'CASSIO HIDEKI FUJISAWA',
      area: 'Coordenador de Engenharia de Controle e Automação'
    },

    {
      coordenador: 'FELIPE DE SOUSA NOBRE',
      area: 'Coordenador de Engenharia Elétrica'
    },

    {
      coordenador: 'FREDERICO ANDRÉ RABELO',
      area: 'Coordenador de Arquitetura e Urbanismo'
    },

    {
      coordenador: 'GENILDA DA SILVA ALEXANDRIA SOUSA',
      area: 'Coordenadora de Design'
    },

    {
      coordenador: 'JORIVER RODRIGUES CANEDO',
      area: 'Coordenador de Análise e Desenvolvimento de Sistemas (ADS)'
    },

    {
      coordenador: 'LUCIANA CASALETTI',
      area: 'Coordenadora de Engenharia de Produção e Membro do Núcleo de Apoio Pedagógico (NAP)'
    },

    {
      coordenador: 'MARTA PEREIRA DA LUZ',
      area: 'Coordenadora de Engenharia Civil'
    },

  
    {
      coordenador: 'MARTHA NASCIMENTO CASTRO',
      area: 'Coordenadora de Agronomia'
    },

    {
      coordenador: 'SALMEN CHAQUIP BUKZEM',
      area: 'Coordenador de Ciências Aeronáuticas'
    }, 

    {
      coordenador: 'ANA FLÁVIA MARINHO DE LIMA GARROTE',
      area: 'Coordenadora do curso de Análise e Desenvolvimento de Sistemas EAD e Membro do Núcleo de Apoio Pedagógico (NAP)'
    },

    {
      coordenador: 'GUSTAVO SIQUEIRA VINHAL',
      area: 'Coordenador do curso de Big Data e Inteligência Artificial EAD'
    },

    {
      coordenador: 'LUDMILLA REIS PINHEIRO DOS SANTOS',
      area: 'Membro do Núcleo de Apoio Pedagógico (NAP)'
    },

    {
      coordenador: 'LUIZ ÁLVARO DE OLIVERIA JÚNIOR',
      area: 'Membro do Núcleo de Apoio Pedagógico (NAP)'
    },

    {
      coordenador: 'LURI SABINA COSME DA SILVA MATOS',
      area: 'Membro do Núcleo de Apoio Pedagógico (NAP)'
    },

    {
      coordenador: 'NERCÍLIO ANTÔNIO URIAS CAVALCANTE JÚNIOR',
      area: 'Estagiário da II JCPOLI'
    },

    {
      coordenador: 'GABRIEL BANDEIRA',
      area: 'Estagiário da II JCPOLI'
    },

    {
      coordenador: 'GABRIEL SOARES RIBEIRO',
      area: 'Estagiário da II JCPOLI'
    },
  ]

export const ComiteListCientific = 
  [
    {
      coordenador: 'Clarimar José Coelho',
      area: 'Pós-Doutorado em Matemática e Computação - USP/ITA'
    },
    {
      coordenador: 'Clóves Gonçalves Rodrigues',
      area: 'Pós-Doutorado em Física - UNICAMP',      
    },  
    {
      coordenador: 'Martha Nascimento Castro',
      area: 'Pós-Doutorado em Agronomia - UNESP'
    },
    {
      coordenador: 'Marcos Lajovic Carneiro',
      area: 'Pós-Doutorado em Engenharia Elétrica - UBO/França'
    },
    {
      coordenador: 'Arlindo Rodrigues Galvão Filho',
      area: 'Doutorado em Ciência da Computação - UFG',
      
    },      
    {
      coordenador: 'Felipe Correa Veloso Dos Santos',
      area: 'Doutorado em Agronomia - UFG',      
    },
    {
      coordenador: 'José Elmo De Menezes',
      area: 'Doutorado em Estatística - USP'
    },
    {
      coordenador: 'José Luiz De Freitas Júnior',
      area: 'Doutorado em Engenharia Elétrica - UFU'
    },   
    
    {
      coordenador: 'Maria José Pereira Dantas',
      area: 'Doutorado em Engenharia Elétrica - UnB'
    },
    
    {
      coordenador: 'Pedro Henrique Maximo Pereira',
      area: 'Doutorado em Arquitetura e Urbanismo - UnB'
    },
    {
      coordenador: 'Ricardo Luiz Machado',
      area: 'Doutorado em Engenharia de Produção - UFSC'
    },
    {
      coordenador: 'Solange Da Silva',
      area: 'Doutorado em Engenharia Elétrica - UFU'
    },
    {
      coordenador: 'Ludmilla Reis Pinheiro Dos Santos',
      area: 'Mestrado em Engenharia Eletrônica e Computação - ITA'
    },
    {
      coordenador: 'Luis Fernando Pagotti',
      area: 'Mestrado em Engenharia Elétrica - UFU'
    },
    {
      coordenador: 'Roberto Marcio Dos Santos',
      area: 'Mestrado em Engenharia Aeronautica - ITA'
    },    
    {
      coordenador: 'Tai Hsuan An',
      area: 'Mestrado em Artes Visuais - UFG'
    },
  ]

